import { BaseQuantity } from "../../interface/functionalityInterface";
// Derived base quantity
// coherent SI unit is m/s

export const Velocity: BaseQuantity = {
  id: "001velocity",
  name: "velocity",
  type: "numeric",
  value: "",
  symbol: "v",
  baseUnit: "m/s",
  selectedUnit: "m/s",
  units: [
    { name: "m/s", fromConst: 1, toConst: 1 },
    { name: "km/h", fromConst: 1000 / 3600, toConst: 3600 / 1000 },
    { name: "mph", fromConst: 1 / 2.23694, toConst: 2.23694 },
    { name: "ft/s", fromConst: 1 / 3.28084, toConst: 3.28084 },
    { name: "yd/s", fromConst: 1 / 1.09361, toConst: 1.09361 },
    { name: "knots", fromConst: 1 / 1.94384, toConst: 1.94384 },
    { name: "c", fromConst: 299792458, toConst: 1 / 299792458 },
  ],
};
